import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Recruitment from "@/pages/Recruitment";
import Offers from "@/pages/Offers";
import Directory from "@/pages/Directory";
import Attendance from "@/pages/Attendance";
import Payroll from "@/pages/Payroll";
import Relieving from "@/pages/Relieving";
import Leaves from "@/pages/Leaves";
import MySpace from "@/pages/MySpace";
import InternalJobs from "@/pages/InternalJobs";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  const { user } = useAuth();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="my-space" element={<MySpace />} />
            <Route path="recruitment" element={<Recruitment />} />
            <Route path="offers" element={<Offers />} />
            <Route path="directory" element={<Directory />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="jobs" element={<InternalJobs />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="relieving" element={<Relieving />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
